import React from 'react';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep8 extends React.Component {
  componentDidMount () {
    if (this.props.location.pathname !== '/ether') {
      this.props.history.push('/ether');
    }
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 8});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 7});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          Get Ether page
        </h2>
        <p>
          We have implemented Ether faucet for everyone to use in ASC. If it goes dry, google is always your friend. Or
          if you are flush with Ether, you can donate to our faucet :).
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep8);



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep8.js